<template>
  <div class="style-empty">
    <img
      class="placeholder"
      :src="
        ['5星', '五星'].includes(stars)
          ? require('@/assets/zs_imgs/style-empty-placeholder.png')
          : require('@/assets/zs_imgs/style-empty-placeholder-zh.png')
      "
    />
    <template v-if="['5星', '五星'].includes(stars) && hasContent">
      <div class="backup-title">先逛逛下方的文字版评测吧</div>
      <div class="backup-list">
        <template v-for="(value, key) in dataSource">
          <a
            v-if="
              value.evaluation.cover.hasValue &&
                value.evaluation.title.hasValue &&
                value.evaluation.cover.value &&
                value.evaluation.title.value
            "
            :key="key + value.evaluation.cover.value"
            :href="value.evaluation.link.value"
            class="backup-item"
            target="_blank"
          >
            <img class="poster" :src="value.evaluation.cover.value" />
            <div class="name">
              {{ value.evaluation.title.value }}
            </div>
          </a>
        </template>
      </div>
    </template>
    <template v-if="!['5星', '五星'].includes(stars)">
      <div class="backup-title">先逛逛下方的综合评测吧</div>
      <div class="backup-list">
        <a class="backup-item" href="https://www.gamekee.com/zsca2/614967.html" target="_blank">
          <img
            class="poster"
            src="//cdnimg-v2.gamekee.com/wiki2.0/images/w_662/h_348/50118/391271/2025/0/24/217422.png?x-image-process=image/resize,m_lfit,h_300,w_300/ignore-error,1&image_process=resize,mid,w_300,h_300"
          />
          <div class="name">
            三四星角色测评
          </div>
        </a>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: "StyleEmpty",
  props: {
    currentStyle: { type: Object, default: () => ({}) },
    dataSource: { type: Object, default: () => ({}) },
    stars: { type: String, default: "" }
  },
  computed: {
    hasContent() {
      if (!Object.keys(this.dataSource).length) return false;
      return Object.values(this.dataSource).some(value => {
        return (
          value.evaluation.cover.hasValue &&
          value.evaluation.title.hasValue &&
          value.evaluation.cover.value &&
          value.evaluation.title.value
        );
      });
    }
  }
};
</script>
<style lang="less" scoped>
.style-empty {
  position: absolute;
  border-radius: 16px;
  background: rgba(226, 231, 230, 0.73);
  width: 1300px;
  top: 150px;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  .placeholder {
    width: 426px;
    height: 297px;
    margin-top: 70px;
    margin-bottom: 32px;
  }
  .backup-title {
    color: #333;
    font-size: 16px;
    margin-bottom: 20px;
  }
  .backup-list {
    box-sizing: content-box;
    padding: 16px;
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.06);
    display: flex;
    column-gap: 16px;
    .backup-item {
      display: flex;
      flex-direction: column;
      .poster {
        width: 136px;
        height: 80px;
        object-fit: cover;
        border-radius: 4px 4px 0 0;
      }
      .name {
        line-height: 28px;
        text-align: center;
        color: #333;
        border-radius: 0 0 4px 4px;
        background-color: #fff;
      }
    }
  }
}
</style>
